<div class="verbatim-details">
  <h2 class="verbatim-details-title">Verbatim</h2>
  <div class="verbatim-text">
    {{ verbatim }}
  </div>
  <section class="category-section">
    <h2 class="verbatim-details-title">Categories</h2>
    @if (loadingCategoryNames) {
      <div class="d-flex flex-col pb-3 pt-3">
        <mat-spinner
          class="flex-item-center"
          [diameter]="45"
          color="primary"
        ></mat-spinner>
      </div>
    }
    @if (categoryNames?.length) {
      <div class="categories">
        <div>
          @for (item of categoryNames; track item) {
            <div class="flex-it flex-row flex-content-start">
              <span
                matTooltip="Category L1"
                class="badge-pill categories-pill-l1"
              >
                {{ item.name }}
              </span>
              @for (child of item.children; track child) {
                <span
                  matTooltip="Category L2"
                  class="badge-pill categories-pill-l2"
                >
                  {{ child.name }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    } @else if (!loadingCategoryNames) {
      <p class="empty-state">No categories for this verbatim</p>
    }
  </section>
</div>
